import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { forkJoin } from 'rxjs';
import { AppointmentTypeService } from 'src/app/services/core/appointment-type/appointment-type.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { ServiceAreasService } from 'src/app/services/core/service-areas-service/service-areas.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-file-parsing',
  templateUrl: './file-parsing.component.html',
  styleUrls: ['./file-parsing.component.css']
})
export class FileParsingComponent implements OnInit {
  selectedFile: File | null = null
  submitted = false;
  invalidFileType = false;
  selFundSrc:any = '';
  fundingSources: any = []
  preLevelOfServices: any = {};
  preSpaceTypes: any = {};
  preAppointmentTypes: any = {};
  preServiceAreas: any = {};
  skippedTrips: any = [];

  constructor(
    private fundingSource: FundingSourceService,
    private tripService: TripService,
    private router: Router,
    private levelOfService: LosService,
    private spaceTypeService: SpaceTypeService,
    private appointmentTypeService: AppointmentTypeService,
    private serviceAreaService: ServiceAreasService 
  ) { }
  ngOnInit() {
    this.getFundingSource();
    this.loadInitialData();
  }

  loadInitialData() {
    const queryparams = {
      limit: 9999,
      isActive: true
    }
    forkJoin({
      levelOfServices: this.levelOfService.getPicker(queryparams),
      spaceTypes: this.spaceTypeService.getPicker(queryparams),
      appointmentTypes: this.appointmentTypeService.getPicker(queryparams),
      serviceAreas: this.serviceAreaService.getPicker(queryparams)
    }).pipe(untilDestroyed(this))
      .subscribe(({ levelOfServices, spaceTypes, appointmentTypes, serviceAreas }: any) => {
        if (levelOfServices?.results?.length) {
          this.preLevelOfServices = levelOfServices.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        if (spaceTypes?.results?.length) {
          this.preSpaceTypes = spaceTypes.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        if (appointmentTypes?.results?.length) {
          this.preAppointmentTypes = appointmentTypes.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }

        if (serviceAreas?.results?.length) {
          this.preServiceAreas = serviceAreas.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      });
  }

  submitFile() {
    this.submitted = true;
    this.skippedTrips = [];
    if (this.selectedFile === null) {
      return;
    }
    this.tripService
      .parseFile(this.selectedFile, this.selFundSrc)
      .pipe(untilDestroyed(this))
      .subscribe((data:any) => {
        if (data) {
          if (data.skippedTrips && data.skippedTrips.length) {
            this.skippedTrips = data.skippedTrips;
          } else {
            this.router.navigateByUrl("/trips");
          }
        }
      })
  }

  onFileSelection(event: any): void {
    const file: File = event.target?.files?.[0];

    if (!file) {
      this.selectedFile = null;
      return;
    }

    const allowedMimeTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
    ];

    const allowedExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop()?.toLowerCase();

    const isValidType =
      allowedMimeTypes.includes(file.type) ||
      (fileExtension && allowedExtensions.includes(fileExtension));

    if (!isValidType) {
      this.selectedFile = null;
      this.invalidFileType = true;
      sweetAlert(
        "Error",
        "Invalid file type. Only Excel files (.xls or .xlsx) are allowed.",
        "error",
        "OK"
      );

      return;
    }

    this.selectedFile = file;
    this.invalidFileType = false;
  }

  deleteFile(fileInput: HTMLInputElement | null) {
    this.selectedFile = null;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  getFundingSource() {
    let queryParams = {
      limit: 9999,
      isActive: true,
    }
    this.fundingSource.getPicker(queryParams).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data && data.results) {
        this.fundingSources = data.results.sort((a: any, b: any) =>
            (a.title).toLowerCase().localeCompare((b.title).toLowerCase())
          );
        // this.preFundingSource = this.fundingSourceList.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
      }
    })
  }

}
